var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { SideImageLayout } from 'hx-ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from 'hx-util';
import { palette } from '@/theme/palette';
import { Button } from '@mui/material';
import { AnimatedCircles } from 'hx-ui';
import { StyledProgress } from '@/components/styled-progress.component';
import { useSetProgress } from 'hx-progress';
import { Divider } from '@/components/divider.component';
import { Instructions } from '@/components/instructions.component';
export function InstructionsStep() {
    useSetProgress(0, 6);
    return (_jsx(SideImageLayout, { leftPanelWidth: "35%", leftPanel: _jsx(Instructions, {}), classNames: { content: 'md:flex md:items-center md:justify-center' }, header: _jsxs("div", __assign({ className: "md:hidden" }, { children: [_jsx(StyledProgress, { className: "px-4 md:px-12 py-6", textClassName: 'font-bold' }), _jsxs("div", __assign({ className: "flex flex-col items-center justify-center md:pt-16 gap-y-6 px-4" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-[41px] text-3xl" }, { children: "Hearing test instructions" })), _jsx(Divider, { className: 'w-full' }), _jsx(Instructions, {})] }))] })), content: _jsx(MainContent, {}) }));
}
function MainContent() {
    var _a = useState('START'), buttonText = _a[0], setButtonText = _a[1];
    var navigate = useNavigate();
    function onClick() {
        if (buttonText !== 'START')
            return;
        var currentCount = 5;
        setButtonText("".concat(currentCount));
        var timerId = setInterval(function () {
            currentCount--;
            if (currentCount > 0) {
                setButtonText("".concat(currentCount));
                return;
            }
            clearInterval(timerId);
            navigate('/din-test');
        }, 1000);
    }
    return (_jsx("div", __assign({ className: 'flex justify-center items-center w-full h-full py-32' }, { children: _jsx(AnimatedButton, __assign({ onClick: onClick, duration: 5 }, { children: _jsx("span", __assign({ className: cn('text-2xl text-white font-bold', {
                    'text-4xl': buttonText !== 'START',
                }) }, { children: buttonText })) })) })));
}
export function AnimatedButton(_a) {
    var children = _a.children, onClick = _a.onClick, duration = _a.duration;
    function colorTransform(index) {
        var colors = [
            palette.roundButton.layers.second,
            palette.roundButton.layers.third,
            palette.roundButton.layers.forth,
        ];
        return colors[index];
    }
    return (_jsx(AnimatedCircles, __assign({ duration: duration, color: palette.common.black, colorTransform: colorTransform, opacity: 1 }, { children: _jsx(Button, __assign({ onClick: onClick, className: 'rounded-full h-28 w-28 min-w-full' }, { children: children })) })));
}
